// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Mint from 'mint-ui'
import VueClipboard from 'vue-clipboard2'
import 'mint-ui/lib/style.css'
import VueJsonp from 'vue-jsonp'
import axios from 'axios'
import qs from 'qs'

Vue.use(VueJsonp)
Vue.use(Mint)
Vue.use(VueClipboard)

Vue.config.productionTip = false

// 全局api接口地址
Vue.prototype.GLOBAL = {
  // 正式
  // 'apiUrl': 'https://app.youquanyun.com',
  // 'apiUrlNative': 'https://native.youquanyun.com',
  // 测试
  'apiUrl': 'http://miaosheng.youquanyun.com',
  'apiUrlNative': 'http://miaosheng.youquanyun.com',
  'bizId': '243',
  'getQueryString': function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) {
      return unescape(r[2])
    }
    return null
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

window.onload = function () {
  getRem(750, 100)
}
window.onresize = function () {
  getRem(750, 100)
}
function getRem (pwidth, prem) {
  var html = document.getElementsByTagName('html')[0]
  var oWidth = document.body.clientWidth || document.documentElement.clientWidth
  html.style.fontSize = oWidth / pwidth * prem + 'px'
}
// 获取连接#后的字符
// function GetRequest () {
//   var str = location.href
//   var num = str.indexOf('#')
//   str = str.substr(num + 1)
//   return str
// }


// WEBPACK FOOTER //
// ./src/main.js